import { render, staticRenderFns } from "./Odnoklassniki.vue?vue&type=template&id=be46146a&scoped=true"
import script from "./Odnoklassniki.vue?vue&type=script&lang=js"
export * from "./Odnoklassniki.vue?vue&type=script&lang=js"
import style0 from "./Odnoklassniki.vue?vue&type=style&index=0&id=be46146a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be46146a",
  null
  
)

export default component.exports